export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Campi del modulo N."])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Manca l'ID richiesto"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hai effettuato l'accesso con successo, continua le operazioni presso lo sportello automatico"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Continua le transazioni ATM"])}
}